import React, { useEffect, useState } from "react";
import { convertDate } from "../../../utils/generalLiveCenter";
import NoDataFound from "../../common/NoDataFound";
import { loadStyles } from "../../../utils/cssLoader";

const PlayerTransferHistory = ({
  ServerData,
  loadCSS = true,
  dataClient = false,
  title,
  dictionary = {},
}) => {
  const [clientData, setClientData] = useState(null);
  const data = dataClient ? clientData : ServerData || [];

  useEffect(() => {
    if (!dataClient) return;
    const container = document?.querySelector(".microservice-cont");
    const raw = container?.getAttribute("data-listingdata");
    if (!raw) return;

    try {
      const parsed = JSON.parse(raw)?.data?.data;
      setClientData(parsed || null);
    } catch (err) {
      console.error("Failed to parse data-listingdata:", err);
    }
  }, [dataClient]);

  useEffect(() => {
    if (loadCSS === "true") {
      loadStyles("footballplayer");
    }
  }, [loadCSS]);
  return (
    <div className="player_transfer_history">
      <h2>Transfer History</h2>
      <div className="global_table player_tranfer">
        {data?.length ? (
          <table>
            <thead>
              <tr>
                <th>{dictionary?.team || "Team"}</th>
                <th>{dictionary?.timeperiod || "Time Period"}</th>
              </tr>
            </thead>
            <tbody>
              <>
                {data?.slice(0, 20)?.map((item, index) => (
                  <tr key={index} className={`${index === 0 ? "current" : ""}`}>
                    <td>
                      <div className="team_name">{item?.ttnm}</div>
                    </td>
                    <td>{convertDate(item?.perd)}</td>
                  </tr>
                ))}
              </>
            </tbody>
          </table>
        ) : (
          <NoDataFound />
        )}
      </div>
    </div>
  );
};

export default PlayerTransferHistory;
